import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=1ae8c856&scoped=true"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=1ae8c856&prod&lang=scss&scoped=true&external"
import style1 from "./manager.vue?vue&type=style&index=1&id=1ae8c856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8c856",
  null
  
)

export default component.exports